import type { ModuleCode } from '../../features/modules/modules';
import type { CanonicalRowFilter } from '../../schemas';
import apiClient from '../index';

export const getAudit = async (auditId: string) => {
	const response = await apiClient.get(`/audits/${auditId}`);
	return response.data;
};

export const createAudit = async (input: {
	clientId: string;
	name: string;
	periodStart: string;
	periodEnd: string;
	module: ModuleCode;
}) => {
	const response = await apiClient.post('/audits', input);
	return response.data;
};

export const setAuditDataFilter = async (
	auditId: string,
	filter: CanonicalRowFilter,
) => {
	const response = await apiClient.put(
		`/audits/${auditId}/data-filter`,
		filter,
	);
	return response.data;
};

export const setAuditAnalysisSlugs = async (
	auditId: string,
	analysisSlugs: string[],
) => {
	const response = await apiClient.patch(`/audits/${auditId}`, {
		analysisSlugs,
	});
	return response.data;
};

export const getAudits = async (module: ModuleCode, clientId?: string) => {
	const params = new URLSearchParams({ module });
	if (clientId) params.set('clientId', clientId);
	const response = await apiClient.get(`/audits?${params}`);
	return response.data;
};

export const getAuditFiles = async (auditId: string) => {
	const response = await apiClient.get(`/audits/${auditId}/files`);
	return response.data;
};
